
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/led-video-wall-rental",
      function () {
        return require("private-next-pages/led-video-wall-rental.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/led-video-wall-rental"])
      });
    }
  